/* Ordinia: publica la altura del banner de cookies (--ord-cookie-h) para que la barra fija de compra no quede tapada. */
(function () {
  var root = document.documentElement;
  var observed = null;
  var resizer = null;

  function apply() {
    var banner = document.getElementById('shopify-pc__banner');
    var h = 0;
    if (banner && banner.getClientRects().length) h = Math.round(banner.getBoundingClientRect().height);
    root.style.setProperty('--ord-cookie-h', h + 'px');
    if (banner !== observed) {
      if (resizer) resizer.disconnect();
      observed = banner;
      if (banner && 'ResizeObserver' in window) {
        resizer = new ResizeObserver(apply);
        resizer.observe(banner);
      }
    }
  }

  new MutationObserver(apply).observe(document.body || root, { childList: true });
  window.addEventListener('resize', apply);
  apply();
})();

/* Ordinia: lo que solo vale hasta una fecha (data-ord-ends="2026-10-09T21:21:00Z") se oculta en cuanto pasa y lo que lo sustituye (data-ord-starts) aparece,
   aunque la página venga de caché. Si la fecha llega con la página abierta, también se oculta. */
(function () {
  function sweep() {
    var now = Date.now(), next = Infinity;
    document.querySelectorAll('[data-ord-ends], [data-ord-starts]').forEach(function (el) {
      var ends = el.hasAttribute('data-ord-ends');
      var t = Date.parse(el.getAttribute(ends ? 'data-ord-ends' : 'data-ord-starts'));
      if (isNaN(t)) return;
      if (now >= t) el.hidden = ends; else next = Math.min(next, t);
    });
    if (next !== Infinity && next - now < 864e5) setTimeout(sweep, next - now + 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep); else sweep();
  document.addEventListener('shopify:section:load', sweep);
})();

/* Ordinia: estado de carga del botón de compra mientras se añade al carrito.
   Se quita al confirmarse (cart:update), si hay error (cart:error) o a los 8 s como red de seguridad. */
(function () {
  var busy = [];
  function clear() {
    busy.forEach(function (b) { b.classList.remove('ord-loading'); b.removeAttribute('aria-busy'); });
    busy = [];
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var btn = form.querySelector('button[name="add"], button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.classList.add('ord-loading');
    btn.setAttribute('aria-busy', 'true');
    busy.push(btn);
    setTimeout(clear, 8000);
  }, true);
  document.addEventListener('cart:update', clear);
  document.addEventListener('cart:error', clear);
})();

/* Ordinia: botón «Aplicar el código» de las ofertas (snippets/ordinia-oferta-meta). Visitar /discount/CODIGO deja
   el código guardado para el pago; si ya estaba aplicado (cookie discount_code), el botón sale como aplicado. */
(function () {
  function applied() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    var c = m ? decodeURIComponent(m[1]) : '';
    try { c = c || sessionStorage.getItem('ord-code') || ''; } catch (e) {}
    return c.toUpperCase();
  }
  function mark(root) {
    var c = applied();
    if (!c) return;
    (root || document).querySelectorAll('[data-ord-apply]').forEach(function (b) {
      if (b.getAttribute('data-ord-apply').toUpperCase() === c) b.classList.add('is-ok');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ord-apply]');
    if (!b || b.classList.contains('is-ok')) return;
    var code = b.getAttribute('data-ord-apply');
    b.classList.add('is-busy');
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        try { sessionStorage.setItem('ord-code', code); } catch (err) {}
        document.querySelectorAll('[data-ord-apply="' + code + '"]').forEach(function (x) { x.classList.remove('is-busy'); x.classList.add('is-ok'); });
      })
      .catch(function () { b.classList.remove('is-busy'); window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mark(); }); else mark();
  document.addEventListener('shopify:section:load', function (e) { mark(e.target); });
  /* Al cambiar de variante la ficha se vuelve a pintar: se revisa como mucho una vez por frame y solo si hay botones. */
  var queued = false;
  new MutationObserver(function () {
    if (queued || !document.querySelector('[data-ord-apply]:not(.is-ok)')) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; mark(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
